export type AnalyticsRange = 'WEEK' | 'MONTH' | 'YEAR';

export type MetricKey =
  | 'PROFILE_VIEW'
  | 'PRODUCT_VIEW'
  | 'REQUEST_RECEIVED'
  | 'CHAT_STARTED'
  | 'DEAL_WON';

export type MetricCounts = Record<MetricKey, number>;

export interface DailyPoint {
  day: string;
  counts: MetricCounts;
}

export interface FunnelTotals {
  views: number;
  chats: number;
  deals: number;
  // Conversion ratios 0..1 (e.g. 0.018 = 1.8%).
  viewsToChats: number;
  chatsToDeals: number;
  overall: number;
}

export interface DashboardData {
  range: AnalyticsRange;
  from: string;
  to: string;
  totals: MetricCounts;
  daily: DailyPoint[];
  funnel: FunnelTotals;
}

// Helper: roll up profile + product views, kept here so views/cards stay aligned.
export function totalViews(totals: MetricCounts): number {
  return totals.PROFILE_VIEW + totals.PRODUCT_VIEW;
}
